import httpClient from './_httpClient';
import httpClientWithoutToken from "./_httpClientWithoutToken";

const END_POINT = '/languages';

const getAllLanguages = (paginated = true) => {
  let params = {};
  if (!paginated) {
    params.paginated = false;
  }
  return httpClientWithoutToken.get(END_POINT , {params})
};
const getAllLanguagesForConnectedScope = () => httpClientWithoutToken.get("languages-of-scope");
const addLanguage = (languageData) => httpClient.post(END_POINT, languageData);
const editLanguage = (id, languageData) => httpClient.put(END_POINT + '/' + id, languageData);
const deleteLanguage = (id) => httpClient.delete(END_POINT + '/' + id);

export {
  getAllLanguages,
  addLanguage,
  editLanguage,
  deleteLanguage,
  getAllLanguagesForConnectedScope
}
